// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportUserForm-errorMessage-Pfq6B {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

.ReportUserForm-displayGrid-BqHG3 {
	display: grid;
	grid-template-columns: 30px auto;
}

.ReportUserForm-radioBtnInputSection-Kc9F7 {
	top: 3px;
}

.ReportUserForm-titleText-FJqRm {
	font-size: 18px;
	font-weight: 700;
	margin: 0;
	padding-bottom: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/ReportUserForm/ReportUserForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACNA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,SAAS;CACT,oBAAoB;AACrB","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../../components/utils.css';\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 30px auto;\n}\n\n.radioBtnInputSection {\n\ttop: 3px;\n}\n\n.titleText {\n\tfont-size: 18px;\n\tfont-weight: 700;\n\tmargin: 0;\n\tpadding-bottom: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ReportUserForm-errorMessage-Pfq6B`,
	"displayGrid": `ReportUserForm-displayGrid-BqHG3`,
	"radioBtnInputSection": `ReportUserForm-radioBtnInputSection-Kc9F7`,
	"titleText": `ReportUserForm-titleText-FJqRm`
};
module.exports = ___CSS_LOADER_EXPORT___;
